import React, { useContext } from "react";
import AppContext from "./hooks/createContext";
import { useTranslation } from 'react-i18next';

interface LoadingModalProps {
  handleResetState: () => void;
}

const LoadingModal = ({ handleResetState }: LoadingModalProps) => {
  const { t } = useTranslation();
  const {
    showLoadingModal: [showLoadingModal, setShowLoadingModal],
    image: [image, setImage],
    isErasing: [isErasing, setIsErasing],
    eraserText: [eraserText, setEraserText],
  } = useContext(AppContext)!;

  console.log("Loading modal");
  
  return (
    <>
      {showLoadingModal && (
        <div className="modal modal-open">
          <div className="flex flex-col items-center justify-center h-72 modal-box">
            <div className="flex">
              <img className="object-contain w-10 mr-3" src={image?.src} />
              <img className="mr-3" src="static/assets/arrow-icn.svg" />
              <img src="static/assets/icn-nn.svg" />
              <img className="mr-3" src="static/assets/arrow-icn.svg" />
              <img src="static/assets/stack.svg" />
            </div>
            <p className="py-4 text-sm md:text-lg">
              {isErasing &&
                eraserText.isEmbedding &&
                t('messages.processing')}
              {isErasing &&
                eraserText.isErase &&
                "Masks can be fed into other open source models"}
              {!isErasing && t('messages.loading')}
            </p>
            <div className="loading-bar"></div>
            <button
              className="pt-8 text-lg font-bold"
              onClick={handleResetState}
            >
              {t('controls.cancel')}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingModal;
